var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Import / Export controls for the JSON-mode editor (TASK-181 followup —
 * moved here from the visual editor footer, where admins kept looking
 * for them on the wrong tab; the buttons themselves say "JSON" so they
 * intuitively belong with the raw-JSON view).
 *
 * Compared to `visual-editor/ImportExportControls`:
 *   - Export downloads the **raw textarea content as-is** (no re-serialise
 *     from a parsed FormConfig). User might be mid-edit; we save what
 *     they see.
 *   - Import reads the chosen file and hands the text straight to the
 *     parent via `onImportedText(s)`. Parent updates the textarea. No
 *     diff dialog — in raw mode the user already sees the JSON, so a
 *     modal preview would be redundant.
 *   - No `optimisticLock` filename suffix — raw mode doesn't have one
 *     in scope at this layer. We embed the date instead for traceability.
 */
import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@folio/stripes/components';
var isoDate = function () { return new Date().toISOString().slice(0, 10); }; // YYYY-MM-DD
var RawImportExport = function (_a) {
    var settingKey = _a.settingKey, rawText = _a.rawText, onImportedText = _a.onImportedText;
    var fileInputRef = useRef(null);
    var handleExport = function () {
        var blob = new Blob([rawText], { type: 'application/json' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = "".concat(settingKey, "-").concat(isoDate(), ".json");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    var handleImportTrigger = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var handleFile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var text;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, file.text()];
                case 1:
                    text = _a.sent();
                    onImportedText(text);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: handleExport, "data-testid": "raw-export-btn", marginBottom0: true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.settings.forms.visual.io.exportButton" })),
        React.createElement(Button, { onClick: handleImportTrigger, "data-testid": "raw-import-btn", marginBottom0: true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.settings.forms.visual.io.importButton" })),
        React.createElement("input", { ref: fileInputRef, type: "file", accept: "application/json,.json", style: { display: 'none' }, "data-testid": "raw-import-file-input", onChange: function (e) {
                var _a;
                var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                if (file)
                    handleFile(file).catch(function () { return undefined; });
                // Reset value so picking the same file again still triggers change
                e.target.value = '';
            } })));
};
export default RawImportExport;
